import React from 'react';
import Select from "../../ShareElements/Select/Select";
import "../../../../../Assets/Styles/PaginationRowSelector.scss"

const PaginationRowSelector = (props) => {
    const translateText = (LabelId) => {
        var Filter = "label_id";
        var Keyword = LabelId;
        var Label = props.LangData.filter((Obj) => {
            return Obj[Filter] === Keyword;
        });
        return Label[0].label_value;
    };

    return (
        <div className="row-count-select">
            <p className="row-info">{translateText("rows_per_page")}</p>
            <Select
                Initial={"5"}
                Options={props.SizeOptions}
                IsWithId
                Id={"row-per-page"}
                ChangeHandler={() =>
                    setTimeout(() => {
                        props.setSize();
                    }, 100)
                }
                ValidationError=""
            />
        </div>
    );
};

export default PaginationRowSelector;
